import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  addToCart,
  deleteItemInCart,
  getCart,
  modifyItemInCart
} from '../../api/api'
import { Payload } from '../reducers/cartReducer'

const addToCartAPI = createAsyncThunk<
  { success: boolean; message: string },
  { product_id: string },
  { rejectValue: { success: boolean; message: string } }
>('cart/add-to-cart', async (data, thunkAPI) => {
  const response = await addToCart(data)
  if (response.data.success) {
    thunkAPI.dispatch(getCartAPI())
  }
  return response.data
})

const getCartAPI = createAsyncThunk<
  Payload,
  undefined,
  { rejectValue: Payload }
>('cart/get-cart', async (_, { rejectWithValue }) => {
  const response = await getCart()
  if (!response.data.success) {
    return rejectWithValue(response.data)
  }
  return response.data
})

const deleteItemInCartAPI = createAsyncThunk<
  { success: boolean; message: string },
  string,
  { rejectValue: { success: boolean; message: string } }
>('cart/delete-item-in-cart', async (itemID, { dispatch, rejectWithValue }) => {
  const response = await deleteItemInCart(itemID)
  if (!response.data.success) {
    return rejectWithValue(response.data)
  }
  dispatch(getCartAPI())
  return response.data
})

const modifyItemInCartAPI = createAsyncThunk<
  { success: boolean; message: string },
  { itemID: string; type: 'add' | 'sub' },
  { rejectValue: { success: boolean; message: string } }
>('cart/modify-item-in-cart', async (data, { dispatch, rejectWithValue }) => {
  const response = await modifyItemInCart(data.itemID, data.type)
  if (!response.data.success) {
    return rejectWithValue(response.data)
  }
  dispatch(getCartAPI())
  return response.data
})

export { addToCartAPI, getCartAPI, deleteItemInCartAPI, modifyItemInCartAPI }
